import { __ } from '@wordpress/i18n';

/**
 * Curved Arrow SVG Component
 * Points from the heading area toward the preview content
 */
const CurvedArrow = () => (
    <svg
        className="sbr-emptystate-arrow"
        width="250"
        height="140"
        viewBox="0 0 250 140"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.58607 0.17067C6.12798 -0.137837 5.50654 -0.0165789 5.19803 0.441506L0.170625 7.90644C-0.137881 8.36452 -0.0166235 8.98597 0.441462 9.29448C0.899547 9.60298 1.52099 9.48172 1.8295 9.02364L6.2983 2.38814L12.9338 6.85695C13.3919 7.16545 14.0133 7.0442 14.3218 6.58611C14.6303 6.12803 14.5091 5.50658 14.051 5.19807L6.58607 0.17067ZM249.527 131.5L249.27 130.534C204.495 142.474 149.457 138.57 102.841 117.39C56.2475 96.2198 18.1349 57.8289 7.00896 0.808596L6.02747 1.00011L5.04598 1.19162C16.3201 58.9713 54.9574 97.8304 102.014 119.211C149.047 140.58 204.56 144.526 249.785 132.466L249.527 131.5Z"
            fill="url(#paint0_linear_emptystate)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_emptystate"
                x1="11.0275"
                y1="23.0001"
                x2="249.027"
                y2="112.5"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#0068A0" />
                <stop offset="1" stopColor="#0068A0" stopOpacity="0" />
            </linearGradient>
        </defs>
    </svg>
);

/**
 * Feature Empty State Component
 *
 * Reusable empty state layout with:
 * - Curved arrow pointing from heading to preview
 * - Preview image demonstrating the feature
 * - Title and description text
 *
 * @param {Object} props
 * @param {string} props.imageUrl - URL to the preview image
 * @param {string} props.imageAlt - Alt text for the preview image
 * @param {string} props.title - Main heading text
 * @param {string} props.description - Description text
 * @param {boolean} props.showArrow - Whether to show the curved arrow (default: true)
 */
const FeatureEmptyState = ( {
    imageUrl,
    imageAlt,
    title,
    description,
    showArrow = true
} ) => {
    return (
        <div className="sbr-emptystate-ctn">
            {/* Curved Arrow */}
            { showArrow && (
                <div className="sbr-emptystate-arrow-wrapper">
                    <CurvedArrow />
                </div>
            ) }

            {/* Preview Image */}
            <div className="sbr-emptystate-popup-preview">
                <img
                    src={ imageUrl }
                    alt={ imageAlt }
                    className="sbr-emptystate-popup-image"
                />
            </div>

            {/* Text Content */}
            <div className="sbr-emptystate-text">
                <h3 className="sbr-emptystate-subtitle">
                    { title }
                </h3>
                <p className="sbr-emptystate-description">
                    { description }
                </p>
            </div>
        </div>
    );
};

export default FeatureEmptyState;
